import { createSlice } from "@reduxjs/toolkit";
import {
  workerClassListAction,
  workerCollectionListAction,
  workerCreateAction,
  workerCsvListAction,
  workerDeleteAction,
  workerEditAction,
  workerListAction,
  workerResetPassAction,
  workerSuspendAction,
  weelklyLoginworkerAction,
} from "../Action/workerAction";

const workerSlice = createSlice({
  name: "worker",
  initialState: {
    loading: false,
    worker: [],
    workerResetPassStatus: "idle",
    workerCollectionListStatus: "idle",
    workerClassListStatus: "idle",
    workerSuspendStatus: "idle",
    workerDeleteStatus: "idle",
    weelklyLoginworkerStatus: "idle",
    workerCreateStatus: "idle",
    workerCsvListStatus: "idle",
    workerEditStatus: "idle",
    avatars: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(workerListAction.pending, (state, action) => {
        state.loading = true;
        state.worker = action?.payload?.data;
      })
      .addCase(workerListAction.fulfilled, (state, action) => {
        state.loading = false;
        state.worker = action?.payload?.data;
      })
      .addCase(workerListAction.rejected, (state, action) => {
        state.loading = false;
        state.worker = action?.payload?.data;
      })
      .addCase(workerResetPassAction.fulfilled, (state, action) => {
        state.workerResetPassStatus = "succeeded";
      })
      .addCase(workerCollectionListAction.fulfilled, (state, action) => {
        state.workerCollectionListStatus = "succeeded";
      })
      .addCase(workerClassListAction.fulfilled, (state, action) => {
        state.workerClassListStatus = "succeeded";
      })
      .addCase(workerSuspendAction.fulfilled, (state, action) => {
        state.workerSuspendStatus = "succeeded";
      })
      .addCase(workerDeleteAction.fulfilled, (state, action) => {
        state.workerDeleteStatus = "succeeded";
      })
      .addCase(weelklyLoginworkerAction.fulfilled, (state, action) => {
        state.weelklyLoginworkerStatus = "succeeded";
      })
      .addCase(workerCreateAction.fulfilled, (state, action) => {
        state.workerCreateStatus = "succeeded";
      })
      .addCase(workerEditAction.fulfilled, (state, action) => {
        state.workerEditStatus = "succeeded";
      })
      .addCase(workerCsvListAction.fulfilled, (state, action) => {
        state.workerCsvListStatus = "succeeded";
      });
  },
});

export default workerSlice.reducer;
